import { withCompInfo } from '@wix/editor-elements-integrations'
import type { BuilderDefinition, BuilderProps } from './Builder'

export const props = withCompInfo<BuilderProps, BuilderDefinition>()(
	// @ts-ignore
	['innerElementsProps', 'compData'],
	// @ts-ignore
	({ innerElementsProps, compData }) => {
		return {
			elementProps: innerElementsProps,
			wix: compData?.wix,
			...compData?.data,
		}
	}
)
